/* SearchQuerySuggestionsBody.tsx generated by @compiled/babel-plugin v0.36.0 */
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["as", "style"],
  _excluded2 = ["as", "style"],
  _excluded3 = ["as", "style"],
  _excluded4 = ["as", "style"];
import { forwardRef } from 'react';
import { ax, ix, CC, CS } from "@compiled/react/runtime";
const _26 = "._18s8ze3t{margin:var(--ds-space-0,0)}";
const _25 = "._qtt8glyw{list-style:none}";
const _24 = "._1yt4p4gn{padding:var(--ds-space-0,0) var(--ds-space-0,0) var(--ds-space-100,8px) var(--ds-space-0,0)}";
const _23 = "._n3tdv77o{padding-bottom:var(--ds-space-025,2px)}";
const _22 = "._1bsb1osq{width:100%}";
const _21 = "._2lx21bp4{flex-direction:column}";
const _20 = "._1e0c1txw{display:flex}";
const _19 = "@media (min-width:64rem){._dm25glyw{display:none}}";
const _18 = "._1e0c1ule{display:block}";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/*
  This component displays the query suggestion results in the typed state
*/

import { BodySmall } from '@atlassian/mpac-primitives';
import { ellipsisCompiled } from '@atlassian/mpac-ui/theme';
import React from 'react';
import { SearchItem, SearchItemType } from '../../SearchItem';
import { desktopOnly, mobileOnly } from '../../SearchUtils/ResponsiveUtils';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const _17 = "@media (min-width:64rem){._dm251ule{display:block}}";
const _16 = "._1e0cglyw{display:none}";
const _15 = "._vwz4f6fq{line-height:18px}";
const _14 = "._1wyboqnp{font-size:.75rem}";
const _13 = "._k48p1nn1{font-weight:400}";
const _12 = "._ect418aq{font-family:var(--ds-font-family-brand-body,\"Charlie Text\",ui-sans-serif,-apple-system,BlinkMacSystemFont,\"Segoe UI\",Ubuntu,\"Helvetica Neue\",sans-serif)}";
const _11 = "._syaz1gjq{color:var(--ds-text-subtle,#44546f)}";
const _10 = "._4cvr1h6o{align-items:center}";
const _9 = "._o5721q9c{white-space:nowrap}";
const _8 = "._1bto1l2s{text-overflow:ellipsis}";
const _7 = "._18u0idpf{margin-left:0}";
const _6 = "._otyridpf{margin-bottom:0}";
const _5 = "._2hwxidpf{margin-right:0}";
const _4 = "._19pkidpf{margin-top:0}";
const _3 = "._1yt41fuv{padding:var(--_67zhvf)}";
const _2 = "._18m915vq{overflow-y:hidden}";
const _ = "._1reo15vq{overflow-x:hidden}";
const baseLabel = {
  padding: " ".concat("var(--ds-space-250, 20px)", " ", "var(--ds-space-300, 24px)", " ", "var(--ds-space-050, 4px)", " ", "var(--ds-space-300, 24px)"),
  alignItems: 'center',
  color: "var(--ds-text-subtle, #44546F)",
  fontFamily: "var(--ds-font-family-brand-body, \"Charlie Text\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
  fontWeight: 400,
  fontSize: '0.75rem',
  lineHeight: '18px',
  margin: 0
};
const LargeLabel = forwardRef((_ref, __cmplr) => {
  let {
      as: C = BodySmall,
      style: __cmpls
    } = _ref,
    __cmplp = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15, _16, _17]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: _objectSpread(_objectSpread({}, __cmpls), {}, {
        "--_67zhvf": ix(" ".concat("var(--ds-space-250, 20px)", " ", "var(--ds-space-300, 24px)", " ", "var(--ds-space-050, 4px)", " ", "var(--ds-space-300, 24px)"))
      }),
      ref: __cmplr,
      className: ax(["_1reo15vq _18m915vq _1yt41fuv _19pkidpf _2hwxidpf _otyridpf _18u0idpf _1bto1l2s _o5721q9c _4cvr1h6o _syaz1gjq _ect418aq _k48p1nn1 _1wyboqnp _vwz4f6fq _1e0cglyw _dm251ule", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  LargeLabel.displayName = 'LargeLabel';
}
const SmallLabel = forwardRef((_ref2, __cmplr) => {
  let {
      as: C = BodySmall,
      style: __cmpls
    } = _ref2,
    __cmplp = _objectWithoutProperties(_ref2, _excluded2);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15, _18, _19]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: _objectSpread(_objectSpread({}, __cmpls), {}, {
        "--_67zhvf": ix(" ".concat("var(--ds-space-250, 20px)", " ", "var(--ds-space-300, 24px)", " ", "var(--ds-space-050, 4px)", " ", "var(--ds-space-300, 24px)"))
      }),
      ref: __cmplr,
      className: ax(["_1reo15vq _18m915vq _1yt41fuv _19pkidpf _2hwxidpf _otyridpf _18u0idpf _1bto1l2s _o5721q9c _4cvr1h6o _syaz1gjq _ect418aq _k48p1nn1 _1wyboqnp _vwz4f6fq _1e0c1ule _dm25glyw", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  SmallLabel.displayName = 'SmallLabel';
}
const Container = forwardRef((_ref3, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref3,
    __cmplp = _objectWithoutProperties(_ref3, _excluded3);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_20, _21, _22, _23]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_1e0c1txw _2lx21bp4 _1bsb1osq _n3tdv77o", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  Container.displayName = 'Container';
}
const SuggestionsList = forwardRef((_ref4, __cmplr) => {
  let {
      as: C = "ul",
      style: __cmpls
    } = _ref4,
    __cmplp = _objectWithoutProperties(_ref4, _excluded4);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_24, _25, _26, _20, _21, _22]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_1yt4p4gn _qtt8glyw _18s8ze3t _1e0c1txw _2lx21bp4 _1bsb1osq", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  SuggestionsList.displayName = 'SuggestionsList';
}
export function SearchQuerySuggestionsBody(_ref5) {
  let {
    query,
    hits,
    autocomplete,
    onAppend
  } = _ref5;
  return /*#__PURE__*/_jsxs(Container, {
    children: [/*#__PURE__*/_jsxs(LargeLabel, {
      as: "h3",
      children: ["Suggestions for '", query, "'"]
    }), /*#__PURE__*/_jsx(SmallLabel, {
      children: "Suggestions"
    }), hits.map((collection, index) => {
      const {
        source,
        items
      } = collection;
      return items.length > 0 && /*#__PURE__*/_jsx(SuggestionsList, _objectSpread(_objectSpread({}, autocomplete.getListProps()), {}, {
        children: items.map(item => {
          const itemProps = _objectSpread(_objectSpread({}, autocomplete.getItemProps({
            item,
            source
          })), {}, {
            role: 'presentation'
          });
          return /*#__PURE__*/_jsx(SearchItem, _objectSpread({
            type: SearchItemType.SEARCH,
            onAppend: onAppend,
            item: item
          }, itemProps), item.objectID);
        })
      }), "source-".concat(index));
    })]
  });
}